import config from './config'
import http from './request';
import api from './api'
import router from '@/router/index'

// 判断是否是移动端
export const isMobile = () => {
  var ua = navigator.userAgent.toLowerCase();
  var bIsIpad = ua.match(/ipad/i) == "ipad";
  var bIsIphoneOs = ua.match(/iphone os/i) == "iphone os";
  var bIsMidp = ua.match(/midp/i) == "midp";
  var bIsUc7 = ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = ua.match(/ucweb/i) == "ucweb";
  var bIsAndroid = ua.match(/android/i) == "android";
  var bIsCE = ua.match(/windows ce/i) == "windows ce";
  var bIsWM = ua.match(/windows mobile/i) == "windows mobile";
  var bIsHarmony = ua.indexOf('harmony') != -1;
  var bIsPhone = ua.indexOf('phone') !== -1;
  var bIsMobile = ua.indexOf('mobile') !== -1;
  if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsHarmony || bIsPhone || bIsMobile) ){
    return false;
  } else return true;
};

export const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    if(ua.indexOf('wxwork') == -1) {
      return true;
    }else {
      return false;
    }
  } else {
    return false;
  }
};

//获取本地缓存的token
export const getToken = () => {
	let token = localStorage.getItem("token");
	return token
}

var jumping = false;
export const jumpWxAuth = () => {
	// localStorage.setItem("token", "fed61eaf9c314649b5e01ad87c59caf0");
	// return;
  if (!isWeixin()) return;
	if(jumping){
		return;
	}
	jumping = true;
	const currentUrl = window.location.href;
    let url = urlencode(currentUrl);
    const code = getQueryString("code");
	if (!code) {
        const authUrl = config.wx_auth_url.replace("#{{appid}}", getAppid()).replace("#{{url}}", url);
        jumping = false;
        window.location.href = authUrl;
    }else {
            let parm = { code: code ,source:'h5_temp'};
    		return http.post(api.lotto.wxLogon,parm)
		      .then((res) => {
		        if(res.sta ==0){
		        	config.TOKEN = res.data.access_token;
					localStorage.setItem("token", res.data.access_token);
					handleZI(res.data.mp_openid);
					window.location.reload();
		        }else if(data.sta == -1){
                   router.push({
			          path: "/errorPage"
			        });
		        }
		        jumping = false;
		    }).catch(function (errors) {
		    	jumping = false;
	            router.push({
		          path: "/errorPage"
		        });
	        })
        }
}

// 身份过期重新登陆
export const reLogin = () => {
  localStorage.clear();
  if (localStorage.getItem("token")) localStorage.removeItem("token");
  jumpWxAuth();
};

export const configApi = (success, error) => {
	console.log('获取api')

	// 如果不是微信环境，跳过微信JS-SDK配置
	if (!isWeixin()) {
		console.log('非微信环境，跳过微信JS-SDK配置');
		if (success) success();
		return;
	}

	let url = urlencode(window.location.href);
	let parm = {
		access_token: config.TOKEN ? config.TOKEN : localStorage.getItem("token"),
		url: window.location.href.split('#')[0],
		source: 'h5_vote',
	};
	http.post(api.lotto.wxSign, parm)
		.then((res) => {
			if (res.sta == 0) {
				console.log('获取jssdk')
				wx.config({
					debug: false,
					appId: getAppid(),
					timestamp: res.data.timestamp,
					nonceStr: res.data.noncestr,
					signature: res.data.sign,
					jsApiList: [
						'onMenuShareTimeline',
						'onMenuShareAppMessage',
						// 'updateAppMessageShareData',
						// 'updateTimelineShareData',
						'previewImage',
						'openLocation',
						'getLocation',
						"wx-open-launch-weapp",
					],
					openTagList: ["wx-open-launch-weapp"]
				});
				wx.ready(function () {
					success && success();
				});
				wx.error(function (res) {
					error && error(res);
				});
			}
		}).catch(function (errors) {
			console.log('errors');
			if (error) error(errors);
		})
}


function urlencode(str) {
	str = (str + '').toString();
	return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

function getAppid() {
	return config.appid;
}

export const getQueryString = (name) => {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) {
		var parm = unescape(r[2]);
		if (parm.indexOf(" ") > -1) {
			parm = parm.replace(/\s+/g, "");
		}
		return parm;
	} else return null;
}

export const setShare = (title, desc, link, imgUrl) => {
    // 如果不是微信环境，跳过微信分享配置
    if (!isWeixin()) {
        console.log('非微信环境，跳过微信分享配置');
        return;
    }

    configApi(() => {
        window.wx.onMenuShareTimeline({
            title: title, // 分享标题
            desc: desc,
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
                console.log("分享朋友圈配置");
                console.log(title, desc, link, imgUrl);
            }
        });
        window.wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc,
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
                // 设置成功
                console.log("分享好友配置");
                console.log(title, desc, link, imgUrl);
            }
        });
    });
}

export const replaceParamVal = (paramName,replaceWith) => {
	var oUrl = window.location.href.toString();
	var re=eval('/('+ paramName+'=)([^&]*)/gi');
	var nUrl = oUrl.replace(re,paramName+'='+replaceWith);
	return nUrl
}

//时间戳转日期 年月日
export const formatDateTime = (inputTime, type) => {
	var date = new Date(inputTime);
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	var minute = date.getMinutes();
	var second = date.getSeconds();
	minute = minute < 10 ? ('0' + minute) : minute;
	second = second < 10 ? ('0' + second) : second;
	//return y + '-' + m + '-' + d;

	if (type == 1) {
		return m + '/' + d + ' ' + h + ':' + minute;
	} else if (type == 2) {
		return y + '-' + m + '-' + d + ' ' + h + ':' + minute;
	} else {
		return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
	}
}


//获取地理
export const getDistance = (lng1, lat1, lng2, lat2) => {
	var radLat1 = rad(lat1);
	var radLat2 = rad(lat2);
	var a = radLat1 - radLat2;
	var b = rad(lng1) - rad(lng2);
	var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
	s = s * 6378.137; //地球半径
	s = Math.round(s * 10000) / 10;
	return s;
}
function rad(d) {
	return d * Math.PI / 180.0;
}

export function compareVersion(v1, v2) {
  v1 = v1.split(".");
  v2 = v2.split(".");
  var len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push("0");
  }
  while (v2.length < len) {
    v2.push("0");
  }
  for (var i = 0; i < len; i++) {
    var num1 = v1[i];
    var num2 = v2[i];
    let max = Math.max(num1.length, num2.length);
    num1 = Math.pow(10, max - num1.length + 1) * num1;
    num2 = Math.pow(10, max - num2.length + 1) * num2;
    if (num1 * 1 > num2 * 1) {
      return 1;
    } else if (num1 * 1 < num2 * 1) {
      return -1;
    }
  }
  return 0;
}

export function getPc() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    var iosVer = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (iosVer) iosVer = parseInt(iosVer[1], 10);
    if (isWeixin) {
      // 还要判断ios和安卓版本。。。
      var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      if (
        compareVersion(wechatInfo[1], "7.0.14") == 1 &&
        ((iosVer && iosVer > 11) || !iosVer)
      ) {
        return 2;
      }
      return 3;
    } else {
      return 1;
    }
  } else {
    // pc
    return 0;
  }
}

export const handleZI = (mp_openid) => {
  localStorage.setItem('clients_id', mp_openid || '')
  _ZHINI({
    action: "init",
    client_id: mp_openid,
  });
}



// WEBPACK FOOTER //
// ./src/utils/common.js